// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"348f1f49","458":"349584e0","518":"4a1c58ea","707":"49271d04","713":"90a63998","731":"e5de28e2","787":"0e164631","944":"2c7f781e"}[chunkId] + ".chunk.js";
};